// axiosMiddleware.js
import axios from 'axios';
import API_URL from '../../../config';

// Crear una instancia de Axios
const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 180000,
});

// Interceptor de solicitud
axiosInstance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');

    // Agregar encabezados personalizados
    // Si es FormData, dejá que Axios setee el boundary automáticamente
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    } else {
      config.headers['Content-Type'] = 'application/json';
    }
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Interceptor de respuesta
axiosInstance.interceptors.response.use(
  response => {
    // Puedes manejar la respuesta aquí
    
    return response;
  },
 error => {
    // Timeout u otros errores de red
    if (error.code === 'ECONNABORTED') {
      return Promise.reject({ customMessage: '⏳ La solicitud tardó demasiado. Por favor, intentá de nuevo.' });
    }

    if (!error.response) {
      return Promise.reject({ customMessage: '⚠️ No se pudo conectar con el servidor.' });
    }

    if (error.response.status === 401) {
      // Dejá que lo maneje el postData
      return Promise.reject(error);
    }

    // Otros errores
    return Promise.reject({
      customMessage: '❌ Error inesperado al comunicarse con el servidor.',
      ...error
    });
  }
);

export default axiosInstance;
